module.exports = __webpack_public_path__ + "img/Insurama-Icono-200px-2.1e9dab58.jpg";